<template>
  <b-modal v-model="isShow" :title="modalTitle" size="lg" centered scrollable no-close-on-backdrop @hide="onReset"
    id="actDataModal">
    <div id="agentRoleModal" class="body-content">
      <!-- 商户 -->
      <b-row class="line">
        <b-col>
          <label>{{ $t("common.clientName") }}</label>
          <v-select v-model.trim="$v.form.brokerId.$model" :disabled="modalType === 'Edit'" :options="brokerList">
            <div slot="no-options">{{ $t("common.noFind") }}</div>
          </v-select>
        </b-col>
      </b-row>

      <b-row class="line">
        <b-col>
          <label><i class="text-danger">*</i>
            <!-- 角色名称 -->
            {{ $t("lanV4.roleName") }}
          </label>
          <b-input-group>
            <b-form-input class="append-input" v-model.trim="$v.form.roleName.$model" placeholder="" maxLength="100"
              :state="chkState('roleName')">
            </b-form-input>
          </b-input-group>
          <p class="text-danger" v-if="!$v.form.roleName.required">
            <!-- 请输入角色名称-->
            {{ $t("userRoleManage.roleNameEmpty") }}
          </p>
        </b-col>
      </b-row>
      <b-row class="line">
        <b-col>
          <label><i class="text-danger">*</i>
            <!-- 分成方式 -->
            {{ $t("lanV4.Sharetype") }}
          </label>
          <b-input-group>
            <span @click="setRedio('0')" :class="radioDisable ? 'radio-disabled' : ''">
              <v-redio :value="form.roleType == 0" :disabled="radioDisable"></v-redio>
              <span class="redio-text">
                <!-- 比例 -->
                {{ $t("lanV4.agentType0") }}
              </span>
              <el-tooltip placement="top">
                <div slot="content" :style="{ width: tipWidth }">
                  {{ $t("lanV4.returnTypeTip1") }}
                </div>
                <img class="icon-wh" src="../../../assets/images/agent_wh.png" alt="" />
              </el-tooltip>
            </span>
            <span class="redio-box" @click="setRedio('1')" :class="radioDisable ? 'radio-disabled' : ''">
              <v-redio :value="form.roleType == 1" :disabled="radioDisable"></v-redio>
              <span class="redio-text">
                <!-- 极差-->
                {{ $t("lanV4.agentType1") }}
              </span>
              <el-tooltip placement="top">
                <div slot="content" :style="{ width: tipWidth }">
                  {{ $t("lanV4.returnTypeTip2") }}
                </div>
                <img class="icon-wh" src="../../../assets/images/agent_wh.png" alt="" />
              </el-tooltip>
            </span>
            <span class="redio-box" @click="setRedio('2')" :class="radioDisable ? 'radio-disabled' : ''">
              <v-redio :value="form.roleType == 2" :disabled="radioDisable"></v-redio>
              <span class="redio-text">
                <!-- 极差-->
                {{ $t("lanV4.agentType2") }}
              </span>
              <el-tooltip placement="top">
                <div slot="content" :style="{ width: tipWidth }">
                  {{ $t("lanV4.returnTypeTip3") }}
                </div>
                <img class="icon-wh" src="../../../assets/images/agent_wh.png" alt="" />
              </el-tooltip>
            </span>
          </b-input-group>
        </b-col>
      </b-row>

      <template v-if="form.roleType == 1 || form.roleType == 2">
        <!-- 级差经纪人返佣比例 -->
        <b-row class="line" v-if="form.roleType == 1">
          <b-col>
            <label><i class="text-danger">*</i>
              <!-- 返佣比例 -->
              {{ $t("lanV4.Rebateratio") }}
            </label>
            <b-input-group>
              <b-form-input class="append-input" v-model.trim="$v.form.returnRatio.$model" placeholder="0~99.99"
                :state="chkState('returnRatio')">
              </b-form-input>
              <div class="append">%</div>
            </b-input-group>
            <p class="text-danger" v-if="!$v.form.returnRatio.required">
              <!-- 请输入 0~ 99.99之间的数字 -->
              {{ $t("lanV4.agentLevelErr") }}
            </p>
            <p class="text-danger" v-if="!$v.form.returnRatio.proofValue">
              <!-- 请输入 0~ 99.99之间的数字 -->
              {{ $t("lanV4.agentLevelErr") }}
            </p>
          </b-col>
        </b-row>
        <!-- 级差经纪人最高返佣等级 -->
        <b-row class="line">
          <b-col>
            <label><i class="text-danger">*</i>
              <!-- 最高返佣等级 -->
              {{ $t("lanV4.RebateratioLever") }}
            </label>
            <b-input-group>
              <b-form-input class="append-input" v-model.trim="$v.form.maxReturnLevel.$model"
                :placeholder="`1~${kvMaxLevel}`" :state="chkState('maxReturnLevel')">
              </b-form-input>
            </b-input-group>
            <p class="text-danger" v-if="!$v.form.maxReturnLevel.required">
              <!-- 请输入1~10的整数-->
              {{ $t("lanV4.agentLevelErr2", { kvMaxLevel: kvMaxLevel }) }}
            </p>
            <p class="text-danger" v-if="!$v.form.maxReturnLevel.proofValue">
              <!-- 请输入1~10的整数-->
              {{ $t("lanV4.agentLevelErr2", { kvMaxLevel: kvMaxLevel }) }}
            </p>
          </b-col>
        </b-row>
      </template>
      <template v-if="form.roleType == 0 || form.roleType == 2">
        <b-row class="line" style="margin-bottom: 0px !important; margin-top: -2px">
          <b-col>
            <label><i class="text-danger">*</i>
              <!-- 比例经纪人返佣比例 -->
              <span v-if="form.roleType == 0">{{ $t("lanV4.Rebateratio") }}</span>
              <span v-if="form.roleType == 2">{{ $t("lanV4.RebateratioSub") }}</span>
            </label>
          </b-col>
        </b-row>
        <template v-for="(item, index) in ladderList">
          <b-row class="line top-people" :key="`title-${index}`" style="margin-bottom: 0 !important;">
            <b-col>
              <label><i class="text-danger">*</i>
                <!-- 1级 2级 -->
                {{ index + 1 }} {{ $t("lanV4.agentLevel") }}
              </label>
            </b-col>
          </b-row>
          <b-row class="line top-people" :key="`content-${index}`">
            <b-col class="top-people-item">
              <b-input-group class="append-jh">
                <b-form-input class="append-jh" :class="{ 'is-invalid': item.returnRatioError }" autocomplete="off"
                  v-model="item.returnRatio" placeholder="0~99.99" maxLength="5"></b-form-input>
                <div class="append">%</div>
                <p class="text-danger" v-if="item.returnRatioError">
                  <!-- 请输入 0~ 99.99之间的数字 -->
                  {{ $t("lanV4.agentLevelErr", { numMax: '99.99' }) }}
                </p>
              </b-input-group>
              <!-- 减号 -->
              <div v-if="index !== 0" class="coustom-icon" @click="delExchange(index)" :style="{
                right:
                  index + 1 == ladderList.length &&
                    ladderList.length < kvMaxLevel &&
                    ladderList.length == index + 1
                    ? '52px !important'
                    : '0px !important',
              }">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.38235 1.51471H5.86765H0V0H5.86765L7.38235 1.90735e-06L13.25 0V1.51471H7.38235Z"
                    fill="#919398" />
                </svg>
              </div>
              <!-- 加号 -->
              <div class="add-icon" @click="addExchange()" v-if="showAdd && ladderList.length == index + 1&&editShowAdd">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.38235 14.25H5.86765V7.38235H0V5.86765H5.86765V0H7.38235V5.86765H13.25V7.38235H7.38235V14.25Z"
                    fill="#919398" />
                </svg>
              </div>
            </b-col>
          </b-row>
        </template>
      </template>
      <b-row v-if="form.roleType == 0 || form.roleType == 2">
        <b-col>
          <p class="text-danger">
            <!-- 注：该角色配置时需要注意多层级时返佣的总比例 -->
            {{ $t('lanV4.roleTypeNote') }}
          </p>
        </b-col>
      </b-row>
      <b-row v-if="showRoleOperationPermissions" class="line role-permission-line">
        <b-col>
          <label>{{ $t("roleManagement.treeData") }}</label>
          <div class="role-permission-checkboxes">
            <el-checkbox v-for="item in permissionOptions" :key="item.field" v-model="form.permission[item.field]"
              :true-label="1" :false-label="0">
              {{ $t(item.labelKey) }}
            </el-checkbox>
          </div>
          <p class="role-permission-tip">
            {{ $t("lanV4.agentOperationPermissionTip") }}
          </p>
        </b-col>
      </b-row>
      <!-- 自返佣开关-->
      <b-row class="line" v-if="form.roleType == 1">
        <b-col>
          <label class="input-text d-inline-block">
            {{ $t("walletBonus.t1") }}:</label>
          <div class="d-inline-block" style="margin-left: 10px;position: relative;top: -6px;">
            <b-form-checkbox class="d-inline-block status-switch" size="lg" v-model="form.switchStatus"
              name="check-button" autocomplete="off" switch>
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer>
      <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
        $t("common.cancel")
      }}</b-button>
      <b-button class="coustom-btn" variant="primary" @click="save">{{
        $t("common.save")
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import { newFixInput, multiply, divide } from "@/apis/newmethods";
import {
  AGENT_OPERATION_PERMISSION_OPTIONS,
  DEFAULT_ROLE_OPERATION_PERMISSIONS,
  getRoleOperationPermissionParams,
  normalizeRoleOperationPermissions,
  shouldShowRoleOperationPermissions,
} from "../agentOperationPermissions";
export default {
  name: "actDataModal",
  props: ["modalShow", "modalType", "itemData", "brokerId"],
  data() {
    return {
      isShow: false,
      modalTitle: null,
      form: {
        brokerId: null, //商户id
        roleName: null, //角色名称
        roleType: 0, //分成方式  0 比例  1极差
        returnRatio: null, //极差返佣比例
        maxReturnLevel: null, //最高返佣等级
        switchStatus: true, //自返佣开关
        permission: {
          ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
        },
      },
      permissionOptions: AGENT_OPERATION_PERMISSION_OPTIONS,
      ladderList: [
        {
          raceIndex: 1, // 阶梯排序
          returnRatio: "", // 比例经纪人返佣比例
          returnRatioError: undefined, //比例经纪人返佣错误提示
        },
      ],
      addSave: false,
      saveFlag: true, //保存防二次点击
      tipWidth: "200px",
      ladderListOld: [], //用户接口旧数据
      actType: null, //大赛类型：0：交易额&收益率大赛 1：交易额大赛  2：收益率大赛
      actStatus: null, //大赛状态：0 未开始 1 进行中 2 已结束
      brokerList: [],
      kvMaxLevel: 10,
      editShowAdd: false,//编辑时是否显示加号
    };
  },
  watch: {
    ladderList: {
      handler(newValue, oldValue) {
        this.checkLadderList();
      },
      deep: true,
    },
    "form.brokerId"(v) {
      if (v) {
        this.getIndex();
      }
    },
    // 角色名称
    "form.roleName"(v) {
      if (v) {
        // this.$nextTick(() => {
        //   this.form.roleName = newFixInput(v, 0, {
        //     minus: true,
        //     num: true,
        //     ints: 6,
        //   });
        // });
      }
    },
    // 极差返佣比例
    "form.returnRatio"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.returnRatio = newFixInput(v, 2, {
            minus: true,
            num: true,
          });
          if (this.isFixed) {
            this.checkLadderList();
          }
        });
      }
    },
    // 极差最高返佣等级
    "form.maxReturnLevel"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.maxReturnLevel = newFixInput(v, 0, {
            minus: true,
            num: true,
          });
        });
      }
    },
    modalShow(v) {
      this.isShow = v;
    },
  },
  computed: {
    radioDisable() {
      return this.modalType === 'Edit' && this.isFixed;
    },
    showAdd() {
      if (this.form.roleType == 0) {
        return this.ladderList.length < this.kvMaxLevel;
      } else if (this.isFixed) {
        return this.ladderList.length < this.fixedMaxLevel;
      } else {
        return false;
      }
    },
    isFixed() {
      return this.form.roleType == '2';
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    url() {
      return this.$store.state.url.agent;
    },
    //比例经纪人最多添加级数 kv配置
    // kvMaxLevel() {
    //   return this.$store.state.baseData.public.maxLevel;
    // },
    fixedMaxLevel() {
      return this.form.maxReturnLevel;
    },
    showRoleOperationPermissions() {
      return shouldShowRoleOperationPermissions(this.form.roleType);
    }
  },
  created() {
    this.getBrokerList();
    this.form.brokerId = this.brokerId
    if (this.modalType && this.modalType === "Add") {
      this.modalTitle = this.$t("lanV4.addRole");
    } else if (this.modalType && this.modalType === "Edit") {
      this.modalTitle = this.$t("lanV4.editRole");
      this.setEditData();
    }
    this.isShow = this.modalShow;
  },
  validations: {
    form: {
      roleName: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
      brokerId: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
      returnRatio: {
        required: requiredIf(function () {
          if (this.form.roleType == 1) {
            return this.addSave;
          } else {
            return false;
          }
        }),
        proofValue: function (v) {
          // 比例不验证 true是不验证
          if (this.form.roleType == 0) {
            return true;
          }
          if (v === "-0") {
            return false;
          }
          if (v) {
            if (this.form.roleType == 1 || this.form.roleType == 2) {
              return Number(v) >= 0 && Number(v) <= 99.99;
            } else {
              return false;
            }
          }
          return true;
        },
      },
      maxReturnLevel: {
        required: requiredIf(function () {
          if (this.form.roleType == 1 || this.form.roleType == 2) {
            return this.addSave;
          } else {
            return false;
          }
        }),
        proofValue: function (v) {
          // 比例不验证 true是不验证
          if (this.form.roleType == 0) {
            return true;
          }
          if (v === "-0") {
            return false;
          }
          if (v) {
            if (this.form.roleType == 1 || this.form.roleType == 2) {
              return Number(v) >= 1 && Number(v) <= this.kvMaxLevel;
            } else {
              return false;
            }
          }
          return true;
        },
      },
    },
  },
  methods: {
    // 获取数据列表
    getIndex() {
      this.editShowAdd = false;
      const paramsData = {
        companyId: this.form.brokerId ? this.form.brokerId.value : this.brokerId,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
        params: paramsData,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.editShowAdd = true;
          this.kvMaxLevel = data.configMaxLevel ? data.configMaxLevel : 10
        } else {
          this.editShowAdd = false;
        }
      });
    },
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            // this.brokerId = arr[0];
            this.form.brokerId = this.brokerId || arr[0]
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    checkLadderList() {
      this.ladderList.forEach((item, index) => {
        this.$nextTick(() => {
          if (item["returnRatio"]) {
            item["returnRatio"] = newFixInput(item["returnRatio"], 2, {
              minus: true,
              ints: 5,
              num: true,
            });
            // 邮箱
            if (this.checkEmail(item["returnRatio"])) {
              item["returnRatioError"] = undefined;
            } else {
              //   请输入0~99.99之间的数字
              item["returnRatioError"] = this.$t("lanV4.agentLevelErr");
            }
          }
          this.aaaaa = new Date().getTime();
        });
      });
    },
    // 乘法
    multiply(v1, v2) {
      return multiply(v1, v2);
    },
    // 除法
    divide(v1, v2) {
      return divide(v1, v2);
    },
    setRedio(val) {
      if (this.radioDisable) {
        return;
      }
      this.form.roleType = val;
      if (!this.showRoleOperationPermissions) {
        this.form.permission = {
          ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
        };
      }
      if (this.modalType === 'Edit' && this.itemData.roleType == val) {
        this.ladderList = [...this.ladderListOld];
      } else {
        this.ladderList = [
          {
            raceIndex: 1, // 阶梯排序
            returnRatio: "", // 比例经纪人返佣比例
            returnRatioError: undefined, //比例经纪人返佣错误提示
          },
        ];
      }
    },
    // 校验邮箱格式
    checkEmail(value) {
      // const maxNum = this.form.returnRatio ? this.form.returnRatio : 99.99;
      const maxNum = 99.99;
      if (this.isFixed ? Number(value) >= 0 && Number(value) > maxNum : Number(value) >= 0 && Number(value) > 99.99) {
        return false;
      } else {
        return true;
      }
    },
    // 验证
    verifyLadderList() {
      let flag = true;
      this.ladderList.forEach((item, index) => {
        if (item["returnRatio"].length === 0) {
          // 请输入0~99.99之间的数字
          item.returnRatioError = this.$t("lanV4.agentLevelErr");
          flag = false;
        }
        if (!this.checkEmail(item["returnRatio"])) {
          flag = false;
        }
      });
      this.aaaaa = new Date().getTime();
      return flag;
    },
    // 添加阶梯
    addExchange() {
      if (!this.verifyLadderList()) return;
      const index = this.ladderList.length;
      const maxLevel = this.form.maxReturnLevel ? this.form.maxReturnLevel : 1;
      if (this.isFixed ? maxLevel > index : true) {
        this.ladderList.push({
          raceIndex: index + 1, // 阶梯排序
          returnRatio: "", // 邮箱
          returnRatioError: undefined,
        });
      }
    },
    // 删除阶梯
    delExchange(index) {
      this.ladderList.splice(index, 1);
      this.ladderListOld.splice(index, 1);
    },
    //编辑设置
    setEditData() {
      this.form.roleName = this.itemData.roleName;
      this.form.roleType = this.itemData.roleType;
      // 比例经纪人返佣比例
      let ladderListOld = []; //旧数据
      const ladderList = []; //新数据
      if (this.form.roleType == 0 || this.form.roleType == 2) {
        if (this.itemData.scaleVos && this.itemData.scaleVos.length) {
          this.itemData.scaleVos.forEach((item, index) => {
            ladderListOld.push({
              raceIndex: index + 1, //索引
              returnRatio: this.multiply(item.scale, 100), // 比例经纪人返佣
              returnRatioError: undefined,
            });
            ladderList.push({
              raceIndex: index + 1, //索引
              returnRatio: this.multiply(item.scale, 100), // 比例经纪人返佣
              returnRatioError: undefined,
            });
          });
          this.ladderListOld = ladderListOld;
          this.ladderList = ladderList;
        }
      }

      if (this.form.roleType == 1) {
        // 极差经纪人返佣比例
        if (this.itemData.scaleVos && this.itemData.scaleVos.length) {
          this.form.returnRatio = this.multiply(
            Number(this.itemData.scaleVos[0].scale),
            100
          );
        } else {
          this.form.returnRatio = 0
        }
        this.form.maxReturnLevel = this.itemData.maxLevel;
      }
      if (this.form.roleType == 2) {
        this.form.maxReturnLevel = this.itemData.maxLevel;
      }
      // 自返佣开关
      this.form.switchStatus = this.itemData.selfRebateStatus == 1 ? true : false;
      this.form.permission = this.showRoleOperationPermissions
        ? normalizeRoleOperationPermissions(this.itemData)
        : {
          ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
        };
    },
    // 保存
    save() {
      this.addSave = true;
      let flag = true;
      if ((this.form.roleType == 0 || this.form.roleType == 2) && !this.verifyLadderList()) {
        flag = false;
        // this.$bus.$emit("alert", {
        //   type: "error",
        //   message: this.$t("lanV4.Information"), //请完善用户信息
        // });
      }
      if (!this.validate()) {
        flag = false;
      }
      if (!this.saveFlag || !flag) return;
      this.saveFlag = false;
      const scaleVos = [];
      if (this.form.roleType == 0 || this.form.roleType == 2) {
        // 比例经纪人 & 固定极差
        this.ladderList.forEach((item, index) => {
          scaleVos.push({
            scale: this.divide(item.returnRatio, 100),
            level: index + 1,
          });
        });
      }
      else {
        // 极差经纪人
        scaleVos.push({
          scale: this.divide(this.form.returnRatio, 100),
          level: 1,
        });
      }

      this.$http({
        url: this.url["co_agent_role_set"],
        params: {
          roleId: this.modalType == "Edit" ? this.itemData.id : undefined, // 编辑列表ID
          roleName: this.form.roleName, //角色名称
          roleType: this.form.roleType, //分成方式
          scaleInfo: scaleVos ? JSON.stringify(scaleVos) : undefined,
          maxLevel: this.form.roleType != 0 ? this.form.maxReturnLevel : undefined,
          // companyId: this.brokerId ? this.brokerId.value : undefined,
          companyId: this.form.brokerId ? this.form.brokerId.value : this.brokerId,
          // 自返佣开关
          selfRebateStatus: this.form.roleType == 1 ? (this.form.switchStatus ? 1 : 0) : undefined, //只有极差有这个开关
          ...getRoleOperationPermissionParams(this.showRoleOperationPermissions ? this.form.permission : DEFAULT_ROLE_OPERATION_PERMISSIONS),
        },
      }).then((data) => {
        this.saveFlag = true;
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          this.$parent.getData();
          this.onReset();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    onReset() {
      this.modalTitle = null;
      this.addSave = false;
      this.form.roleName = null; //角色名称
      this.form.brokerId = null;
      this.form.permission = {
        ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
      };
      this.ladderList = [
        {
          raceIndex: 1, // 阶梯排序
          returnRatio: "", // 邮箱
          returnRatioError: "", //邮箱错误提示
        },
      ];
      this.$emit("changeModalShow", false);
      this.$emit("changeModalType", null);
      this.$v.form.$reset();
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>

<style lang="scss">
#agentRoleModal {
  .icon-wh {
    width: 12px;
    height: 12px;
    position: relative;
    top: 1px;
  }

  .redio-text {
    margin-left: 8px;
    color: #263954;
    font-family: HarmonyOS-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    top: 2px;
  }

  .redio-box {
    margin-left: 12px;
  }

  .radio-disabled {
    cursor: not-allowed;
  }

  .role-permission-line {
    margin-top: 4px;
  }

  .role-permission-checkboxes {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;

    .el-checkbox {
      margin-right: 16px;
      padding: 0 8px;
    }

    .el-checkbox__label {
      white-space: nowrap;
    }

    .el-checkbox.is-checked {
      background: transparent !important;
    }

    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: transparent;
      border-color: #095BE8;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      border-color: #095BE8;
    }

    .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
      background-color: #095BE8;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #095BE8;
    }
  }

  .common-redio {
    svg {
      circle[stroke="#2B61FF"] {
        stroke: #095BE8;
      }

      circle[fill="#2B61FF"] {
        fill: #095BE8;
      }
    }
  }

  .status-switch {
    .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #095BE8;
      border-color: #095BE8;
    }
  }

  .role-permission-tip {
    color: #93979D !important;
    font-family: HarmonyOS-Regular;
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0 0;
  }

  .append {
    top: 10px;
  }

  .append-jh {
    width: 322px;
  }

  .form-control:disabled,
  .form-control[readonly] {
    color: #93979d !important;
    border: none !important;
  }

  .top-people {
    .col {
      flex-basis: auto;
    }

    .top-people-item {
      position: relative;
      display: flex;
      flex-direction: row;
      gap: 10px;

      .append-jh {
        flex: 1;
        width: auto;

        .text-danger {
          position: absolute;
          top: 40px;
        }
      }

      img {
        width: 15.5px;
        height: 15.5px;
        position: absolute;
        top: 49px;
        right: 5px;
      }
    }
  }

  .top-wh {
    margin-top: 23px;

    img {
      width: 16px;
      position: relative;
      top: -2px;
    }
  }

  .tip {
    color: #ffc64b;
    font-size: 12px;
    line-height: 17px;
    font-family: "HarmonyOS-Regular" !important;
    margin-top: 8px;
  }

  .coustom-icon {
    cursor: pointer;
    width: 40px;
    height: 40px;
    background: #f5f7fa;
    border-radius: 4px;
    text-align: center;
    line-height: 40px;
    flex-shrink: 0;
    //position: absolute;
    //right: 47px;
    //top: 28px;
  }

  .add-icon {
    width: 40px;
    height: 40px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    //position: absolute;
    //right: 0px;
    //top: 28px;
  }
}
</style>
